import { render, staticRenderFns } from "./StudentMail.vue?vue&type=template&id=3f823233&"
import script from "./StudentMail.vue?vue&type=script&lang=js&"
export * from "./StudentMail.vue?vue&type=script&lang=js&"
import style0 from "./StudentMail.vue?vue&type=style&index=0&id=3f823233&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports